import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Spinner } from "@/components/bits";
import { History as HistoryIcon } from "lucide-react";

const ACTION_LABELS = {
  proposal_created: "Proposal created",
  proposal_approved: "Approved",
  proposal_rejected: "Rejected",
  publish_dry_run: "Dry-run simulated",
  publish_live: "Published (live)",
  publish_blocked_content_changed: "Publish blocked — content changed",
  publish_error: "Publish error",
  wp_connect: "WordPress connected",
  mode_change: "Mode changed",
  watchlist_scan: "Watchlist scan",
};

export default function History() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    client.get("/audit").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl">
      <p className="text-xs font-mono uppercase tracking-widest text-blue-700">Audit Log · 30-Day Content Retention</p>
      <h1 className="font-serif text-3xl font-bold text-slate-900 mt-1 mb-6">Update History</h1>

      {loading && <Spinner label="Loading audit history…" />}
      {!loading && rows.length === 0 && <div className="rounded-xl border border-dashed border-slate-300 p-6 text-center text-slate-500">No audit entries yet.</div>}

      <div data-testid="audit-log-history-table" className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs font-mono uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-3">When</th>
              <th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Roles</th>
              <th className="px-4 py-3">Target</th>
              <th className="px-4 py-3">Baseline Hash</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.map((r) => (
              <tr key={r.id} onClick={() => setOpen(open === r.id ? null : r.id)} className="cursor-pointer hover:bg-slate-50">
                <td className="px-4 py-3 text-xs text-slate-500 whitespace-nowrap">{new Date(r.timestamp).toLocaleString()}</td>
                <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700"><HistoryIcon className="h-3 w-3" /> {ACTION_LABELS[r.action] || r.action}</span></td>
                <td className="px-4 py-3 text-xs text-slate-700">{r.user}</td>
                <td className="px-4 py-3 text-xs text-slate-500 font-mono">{(r.roles || []).join(",")}</td>
                <td className="px-4 py-3 text-xs text-slate-600 max-w-xs truncate">{r.post_title || r.meta?.post_id || "—"}</td>
                <td className="px-4 py-3 text-xs font-mono text-slate-400">{(r.baseline_hash || "").slice(0, 12) || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
